import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createPrEnquiryShareLink, fetchPrEnquiryShareLink } from "services/prEnquiryApi";
import { buildPrEnquiryUrl } from "utils/prEnquiryForm";

const SHARE_LINK_KEY = ["pr-enquiry-share-link"];

/**
 * The organization's public PR enquiry form URL ("" while it has none), and `create` to issue a
 * link. A created link is written straight into the cache, so every screen sharing the form sees
 * it without a refetch. `create` takes per-call `{ onSuccess, onError }` for the caller's toasts.
 */
const usePrEnquiryShareLink = ({ enabled = true } = {}) => {
  const queryClient = useQueryClient();
  const link = useQuery(SHARE_LINK_KEY, fetchPrEnquiryShareLink, {
    enabled,
    refetchOnWindowFocus: false,
  });
  const creation = useMutation(createPrEnquiryShareLink, {
    onSuccess: (created) => queryClient.setQueryData(SHARE_LINK_KEY, created),
  });

  return {
    url: buildPrEnquiryUrl(link.data?.slug),
    isLoading: enabled && link.isLoading,
    create: (callbacks) => creation.mutate(undefined, callbacks),
    creating: creation.isLoading,
  };
};

export default usePrEnquiryShareLink;
